import { colorText } from '../../mixins/text/textColorLegacy';
export const defaultTextTheme = {
  Text: {
    color: Object.assign(Object.assign({}, colorText), {
      custom: 'inherit'
    })
  }
};